<template>
  <div class="game-container" id="meal-plan" :style="{ backgroundImage: `url(${backgroundImage})` }">
    <a class="back-button" @click="goBack">⬅ {{back_label[language]}}</a>
    
    <div class="white-area"></div>

    <!-- <button class="screenshot-button" @click="captureScreenshot">Save</button> -->
    <!-- <button class="export-button" @click="exportPDF">Download PDF</button> -->
    <button class="export-button" @click="downloadPDF"> {{download_label[language]}}</button>
    <button class="reset-button" @click="resetMealPlan"> {{reset_label[language]}}</button>
    
    <!-- Dropdown for selecting a day with support for multiple languages -->
    <div class="selected-day">
      <select v-model="selectedDay" id="daySelect">
        <option 
          v-for="day in defaultMealPlan" 
          :key="day.name.en" 
          :value="day.name.en">
          {{ day.name[language] }}
        </option>
      </select>
    </div>


    <!-- Vertical Meal Plan Table for the selected day with multi-language support -->
    <div id="meal-plan">
      <h2>{{ selectedDayData.name[language] }}</h2>
      <table class="meal-table">
        <tbody>
          <!-- Breakfast -->
          <tr>
            <td>{{breakfast_label[language]}}</td>
            <td>
              <div
                v-for="(item, index) in selectedDayData.breakfast"
                :key="index"
                class="meal-item"
                @click="openEdit(selectedDayIndex, 'breakfast', index)"
              >
                <img :src="item.src" :alt="item.name[language] || item.name" class="meal-img" />
                <span>{{ item.name[language] || item.name }}</span>
              </div>
            </td>
          </tr>
          <!-- Morning Snack -->
          <tr>
            <td>{{morningSnack_label[language]}}</td>
            <td>
              <div
                v-for="(item, index) in selectedDayData.morning_snack"
                :key="index"
                class="meal-item"
                @click="openEdit(selectedDayIndex, 'morning_snack', index)"
              >
                <img :src="item.src" :alt="item.name[language] || item.name" class="meal-img" />
                <span>{{ item.name[language] || item.name }}</span>
              </div>
            </td>
          </tr>
          <!-- Lunch -->
          <tr>
            <td>{{lunch_label[language]}}</td>
            <td>
              <div
                v-for="(item, index) in selectedDayData.lunch"
                :key="index"
                class="meal-item"
                @click="openEdit(selectedDayIndex, 'lunch', index)"
              >
                <img :src="item.src" :alt="item.name[language] || item.name" class="meal-img" />
                <span>{{ item.name[language] || item.name }}</span>
              </div>
            </td>
          </tr>
          <!-- Afternoon Snack -->
          <tr>
            <td>{{afternoonSnack_label[language]}}</td>
            <td>
              <div
                v-for="(item, index) in selectedDayData.afternoon_snack"
                :key="index"
                class="meal-item"
                @click="openEdit(selectedDayIndex, 'afternoon_snack', index)"
              >
                <img :src="item.src" :alt="item.name[language] || item.name" class="meal-img" />
                <span>{{ item.name[language] || item.name }}</span>
              </div>
            </td>
          </tr>
          <!-- Dinner -->
          <tr>
            <td>{{dinner_label[language]}}</td>
            <td>
              <div
                v-for="(item, index) in selectedDayData.dinner"
                :key="index"
                class="meal-item"
                @click="openEdit(selectedDayIndex, 'dinner', index)"
              >
                <img :src="item.src" :alt="item.name[language] || item.name" class="meal-img" />
                <span>{{ item.name[language] || item.name }}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Swap Buttons -->
      <div class="swap-buttons">
        <button @click="openSwapModal"> {{swapDay_label[language]}}</button>
        <button @click="swapSnacks(selectedDayIndex)"> {{swapSnacks_label[language]}}</button>
        <button @click="swapLunchDinner(selectedDayIndex)"> {{swapLunchDinner_label[language]}}</button>
      </div>
    </div>
    <!-- Modal for swapping meal plans -->
    <div v-if="showSwapModal" class="modal-overlay" @click.self="showSwapModal = false">
      <div class="modal">
        <h3>{{swapDay_label[language]}}</h3>
        <select v-model="swapDay">
          <option v-for="day in defaultMealPlan" :key="day.name.en" :value="day.name.en">{{ day.name[language] }}</option>
        </select>
        <select v-model="swapWithDay">
          <option v-for="day in defaultMealPlan" :key="day.name.en" :value="day.name.en">{{ day.name[language] }}</option>
        </select>
        <div class="modal-actions">
          <button class="confirm-button" @click="confirmSwap">{{confirm_label[language]}}</button>
          <button class="cancel-button" @click="showSwapModal = false">{{cancel_label[language]}}</button>
        </div>
      </div>
    </div>
    <div id="title-plan">
      <h2>{{weekPlan_label[language]}}</h2>
    </div>
    <!-- Hidden container for exporting the full week's plan -->
    <div id="all-meal-plan">
      <h2>{{weekPlan_label[language]}}</h2>
      <div v-for="(day) in mealPlan" :key="day.id" class="day-plan">
        <h3>{{ day.name[language] }}</h3>
        <table class="meal-table">
          <thead>
            <!-- <tr>
              <th>Meal Type</th>
              <th>Meal Items</th>
            </tr> -->
          </thead>
          <tbody>
            <!-- Breakfast -->
            <tr>
              <td>{{breakfast_label[language]}}</td>
              <td>
                <div v-for="(item, index) in day.breakfast" :key="index" class="meal-item">
                  <img :src="item.src" :alt="item.name[language] || item.name" class="meal-img" />
                  <span>{{ item.name[language] || item.name }}</span>
                </div>
              </td>
            </tr>
            <!-- Morning Snack -->
            <tr>
              <td>{{morningSnack_label[language]}}</td>
              <td>
                <div v-for="(item, index) in day.morning_snack" :key="index" class="meal-item">
                  <img :src="item.src" :alt="item.name[language] || item.name" class="meal-img" />
                  <span>{{ item.name[language] || item.name }}</span>
                </div>
              </td>
            </tr>
            <!-- Lunch -->
            <tr>
              <td>{{lunch_label[language]}}</td>
              <td>
                <div v-for="(item, index) in day.lunch" :key="index" class="meal-item">
                  <img :src="item.src" :alt="item.name[language] || item.name" class="meal-img" />
                  <span>{{ item.name[language] || item.name }}</span>
                </div>
              </td>
            </tr>
            <!-- Afternoon Snack -->
            <tr>
              <td>{{afternoonSnack_label[language]}}</td>
              <td>
                <div v-for="(item, index) in day.afternoon_snack" :key="index" class="meal-item">
                  <img :src="item.src" :alt="item.name[language] || item.name" class="meal-img" />
                  <span>{{ item.name[language] || item.name }}</span>
                </div>
              </td>
            </tr>
            <!-- Dinner -->
            <tr>
              <td>{{dinner_label[language]}}</td>
              <td>
                <div v-for="(item, index) in day.dinner" :key="index" class="meal-item">
                  <img :src="item.src" :alt="item.name[language] || item.name" class="meal-img" />
                  <span>{{ item.name[language] || item.name }}</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal for meal editing -->
    <div v-if="showEditModal" class="modal-overlay" @click.self="closeEdit">
      <div class="modal">
        <!-- <h2>Edit Meal Item</h2> -->
        <!-- <p><strong>Current:</strong></p> -->
        <img :src="selectedAlternative.src" :alt="selectedAlternative.name[language] || selectedAlternative.name" class="meal-img-large" />
        <!-- <p>{{ selectedAlternative.name }}</p> -->
        <!-- <h2>{{ selectedAlternative.name }}</h2> -->
        <p>
          <!-- <label for="alternative">Select alternative:</label> -->
        </p>
        <select v-model="selectedAlternative" id="alternative">
          <option v-for="option in currentAlternatives" :key="option.src" :value="option">
            {{ option.name[language] || option.name }}
          </option>
        </select>
        <div class="modal-actions">
          <button @click="saveAlternativeMeal">{{save_label[language]}}</button>
          <button @click="closeEdit">{{cancel_label[language]}}</button>
        </div>
      </div>
    </div>
  </div>

<ProfPepOverlay :message="overlayMessage[language]" :visible="isOverlayVisible" @start-game="onStartGame" />
</template>

<script>
// Import your images and required libraries (e.g., jsPDF, html2canvas)
import ProfPepOverlay from '@/components/ProfPepOverlay.vue';
import { Howler } from 'howler';
import { sounds } from '@/utils/sounds';
import yogurt from '@/assets/game-elements/breakfast/yogurt.png';
import fruits from '@/assets/game-elements/breakfast/fruits.png';
import oats from '@/assets/game-elements/breakfast/oats.png';
import nuts from '@/assets/game-elements/breakfast/nuts.png';
import walnuts from '@/assets/game-elements/breakfast/walnuts.png';
import ricotta from '@/assets/game-elements/breakfast/ricotta_cheese.png';
import toast from '@/assets/game-elements/breakfast/toast.png';
import cookie from '@/assets/game-elements/breakfast/cookie.png';
import milk from '@/assets/game-elements/breakfast/milk.png';
import muesli from '@/assets/game-elements/breakfast/muesli.png';
import eggs from '@/assets/game-elements/breakfast/eggs.png';
import avocado from '@/assets/game-elements/breakfast/avocado.png';
import peanut_butter from '@/assets/game-elements/breakfast/peanut butter.png';
import whole_grain_bread from '@/assets/game-elements/dinner/multi-grain bread.png';
import apple from '@/assets/game-elements/breakfast/apple.png';
import banana from '@/assets/game-elements/breakfast/banana.png';
import chia_seeds from '@/assets/game-elements/breakfast/chia_seeds.png';

import almonds from '@/assets/game-elements/morning_snack/almonds.png';
import cashews from '@/assets/game-elements/morning_snack/cashews.png';
import pear from '@/assets/game-elements/morning_snack/pear.png';
import cheese from '@/assets/game-elements/morning_snack/cheese.png';
import pineapple from '@/assets/game-elements/morning_snack/pineapple.png';
import bresaola from '@/assets/game-elements/morning_snack/bresaola.png';
import fresh_cheese from '@/assets/game-elements/lunch/fresh cheese.png';
import arugula from '@/assets/game-elements/morning_snack/arugula.png';
import dried_fruits from '@/assets/game-elements/morning_snack/dried_fruits.png';
import popcorn from '@/assets/game-elements/morning_snack/pop_corn.png';
import nutritional_yeast from '@/assets/game-elements/morning_snack/nutritional_yeast.png';
import nut_butter from '@/assets/game-elements/morning_snack/peanut butter.png';

import beef from '@/assets/game-elements/lunch/beef.png';
import wild_boar from '@/assets/game-elements/lunch/wild_boar.png';
import chicken from '@/assets/game-elements/lunch/chicken.png';
import whole_wheat_bread from '@/assets/game-elements/breakfast/whole-wheat bread.png';
import barley from '@/assets/game-elements/lunch/barley.png';
import salmon from '@/assets/game-elements/lunch/salmon - tuna.png';
import tuna from '@/assets/game-elements/lunch/salmon - tuna.png';
import quinoa from '@/assets/game-elements/lunch/quinoa.png';
import rice from '@/assets/game-elements/lunch/rice.png';
import chickpeas from '@/assets/game-elements/lunch/chickpeas.png';
import beans from '@/assets/game-elements/lunch/beans.png';
import bulgur from '@/assets/game-elements/lunch/bulgur.png';
import couscous from '@/assets/game-elements/lunch/couscous.png';
import mackerel from '@/assets/game-elements/lunch/mackerel.png';
import trout from '@/assets/game-elements/lunch/trout.png';
import rye_bread from '@/assets/game-elements/lunch/rye bread.png';
import pizza from '@/assets/game-elements/lunch/pizza.png';
import lentils from '@/assets/game-elements/lunch/lentils.png';
import farro from '@/assets/game-elements/lunch/farro.png';

import cereals from '@/assets/game-elements/afternoon_snack/cereals.png';
import hummus from '@/assets/game-elements/afternoon_snack/hummus.png';
import veggetables from '@/assets/game-elements/afternoon_snack/veggetables.png';
// import oil from '@/assets/game-elements/dinner/oil-2.png';
import fruit_juice from '@/assets/game-elements/afternoon_snack/fruit juice.png';
import berries from '@/assets/game-elements/afternoon_snack/berries.png';
import carrots from '@/assets/game-elements/afternoon_snack/carrots.png';
import cucumber from '@/assets/game-elements/afternoon_snack/cucumber.png';

import fish from '@/assets/game-elements/dinner/white fish.png';
import pasta from '@/assets/game-elements/dinner/whole-wheat pasta.png';
import peas from '@/assets/game-elements/dinner/peas.png';
import turkey from '@/assets/game-elements/dinner/turkey.png';
// import rabbit from '@/assets/game-elements/dinner/rabbit.png';
import swordfish from '@/assets/game-elements/dinner/swordfish.png';
import shellfish from '@/assets/game-elements/dinner/shellfish.png';
import buckwheat from '@/assets/game-elements/dinner/buckwheat.png';

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export default {
  components: {
    ProfPepOverlay,
  },
  name: 'BuildWeekGame',
  data() {
    return {
      audio: null,
      language: 'en',
      save_label: {en: "Save", el: "Αποθήκευση", it: "Salva", ro: "Salvează", uk: "Зберегти"},
      confirm_label: {en: "Confirm", el: "Επιβεβαίωση", it: "Confermare", ro: "Confirmă", uk: "Підтвердити"},
      cancel_label: {en: "Cancel", el: "Ακύρωση", it: "Annulla", ro: "Anulează", uk: "Скасувати"},
      weekPlan_label: {en: "Weekly meal plan", el: "Εβδομαδιαίο πρόγραμμα γευμάτων", it: "Piano settimanale dei pasti", ro: "Plan de masă săptămânal", uk: "Тижневий план харчування"},
      breakfast_label: {en: "Breakfast", el: "Πρωινό", it: "Colazione", ro: "Mic dejun", uk: "Сніданок"},
      morningSnack_label: {en: "Morning snack", el: "Πρωινό σνακ", it: "Spuntino mattutino", ro: "Gustare de dimineață", uk: "Ранковий перекус"},
      lunch_label: {en: "Lunch", el: "Μεσημεριανό", it: "Pranzo", ro: "Prânz", uk: "Обід"},
      afternoonSnack_label: {en: "Afternoon snack", el: "Απογευματινό σνακ", it: "Spuntino pomeridiano", ro: "Gustare de după-amiază", uk: "Післяобідній перекус"},
      dinner_label: {en: "Dinner", el: "Βραδινό", it: "Cena", ro: "Cină", uk: "Вечеря"},
      swapLunchDinner_label: {en: "Swap lunch/dinner", el: "Αντάλλαξε μεσημεριανό/βραδινό", it: "Scambia pranzo/cena", ro: "Schimbă prânzul/cina", uk: "Поміняти обід/вечерю місцями" },
      swapSnacks_label: {en: "Swap snacks", el: "Αντάλλαξε τα σνακ", it: "Scambia gli spuntini", ro: "Schimbă gustările", uk: "Поміняти перекуси місцями"}, 
      swapDay_label: {en:"Swap day meals", el:"Αντάλλαξε τα γεύματα της ημέρας", it:"Scambia i pasti del giorno", ro:"Schimbă mesele zilei", uk:"Поміняти страви дня місцями"},
      download_label: {en:"Download PDF", el:"Λήψη PDF", it:"Scarica PDF", ro:"Descarcă PDF", uk:"Завантажити PDF"},
      reset_label : {en:"Reset", el:"Επαναφορά", it:"Reimposta", ro:"Resetare", uk:"Скинути"},
      back_label : {en:"Back", el:"Πίσω", it:"Indietro", ro:"Înapoi", uk:"Назад"},
      Round_label: {en:"Round", el:"Γύρος", it:"Round", ro:"Rundă", uk:"Раунд"},
      timeleft_label: {en:"Time left", el:"Χρόνος", it:"Tempo rimanente", ro:"Timp rămas", uk:"Час залишився"},
      score_label: {en:"Score", el:"Πόντοι", it:"Punteggio", ro:"Scor", uk:"Очки"},
      correct_label: {en:"Correct!", el:"Σωστά!", it:"Corretto", ro:"Corect!", uk:"Правильно!"},
      wrong_label: {en:"Wrong...", el:"Λάθος...", it:"Sbagliato", ro:"Greșit...", uk:"Неправильно..."},

      overlayMessage: {en: "Build your week plan!", el: "Οργάνωσε το εβδομαδιαίο σου πρόγραμμα διατροφής!", it: "Costruisci il piano della tua settimana!", ro: "Construiește planul tău săptămânal!", uk: "Створи свій план на тиждень!"},
      isOverlayVisible: true,
      backgroundImage: require('@/assets/game-backgrounds/background.jpg'),
      showSwapModal: false,
      selectedDay: null,
      swapDay: null,
      swapWithDay: null,
      showEditModal: false,
      currentMeal: {},
      currentAlternatives: [],
      selectedAlternative: null,
      currentDayIndex: null,
      currentMealKey: '',
      currentFoodIndex: null,
      // Array for day names
      // dayNames: {
      //     en: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      //     el: ['Δευτέρα', 'Τρίτη', 'Τετάρτη', 'Πέμπτη', 'Παρασκευή', 'Σάββατο', 'Κυριακή'],
      //     it: ['Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato', 'Domenica'],
      //     ro: ['Luni', 'Marți', 'Miercuri', 'Joi', 'Vineri', 'Sâmbătă', 'Duminică'],
      //     uk: ['Понеділок', 'Вівторок', 'Середа', 'Четвер', 'П’ятниця', 'Субота', 'Неділя']
      // },

      dayNames: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      // Define alternative groups (customize as needed)
      alternativeGroups: {
        yogurt: [
          { name: {en: "edamer cheese", el: "τυρί ένταμερ", it: "formaggio edamer", ro: "brânză edamer", uk: "сир едамер" }, src: cheese, group: 'yogurt' },
          { name: {en: "fresh cheese", el: "φρέσκο τυρί", it: "formaggio fresco", ro: "brânză proaspătă", uk: "свіжий сир" }, src: fresh_cheese, group: 'yogurt' },
          { name: {en: "greek yogurt", el: "ελληνικό γιαούρτι", it: "yogurt greco", ro: "iaurt grecesc", uk: "грецький йогурт" }, src: yogurt, group: 'yogurt' },
          { name: {en:'milk', el:'γάλα', it:'latte', ro:'lapte', uk:'молоко'}, src: milk, group: 'yogurt' },
          { name: {en:'ricotta cheese', el:'τυρί ρικότα', it:'ricotta', ro:'brânză ricotta', uk:'сир Рікотта'}, src: ricotta, group: 'yogurt' },
          { name: {en:'yogurt', el:'γιαούρτι', it:'yogurt', ro:'iaurt', uk:'йогурт'}, src: yogurt, group: 'yogurt' },
        ],
        fruit: [
          { name: {en:'apple', el:'μήλο', it:'mela', ro:'măr', uk:'яблуко'}, src: apple, group: 'fruit' }, 
          { name: {en:'avocado', el:'αβοκάντο', it:'avocado', ro:'avocado', uk:'авокадо'}, src: avocado, group: 'fruit' },   
          { name: {en:'banana', el:'μπανάνα', it:'banana', ro:'banană', uk:'банан'}, src: banana, group: 'fruit' },   
          { name: {en:'berries', el:'μούρα', it:'bacche', ro:'fructe de padure', uk:'ягоди'}, src: berries, group: 'fruit' }, 
          { name: {en:'dried fruits', el:'αποξηραμένα φρούτα', it:'frutta secca', ro:'fructe uscate', uk:'сухофрукти'}, src: dried_fruits, group: 'fruit' },   
          { name: {en:{en:'fruit juice', el:'χυμός φρούτων', it:'frutta succo', ro:'suc de fructe', uk:'фруктовий сік'}, el:'χυμός φρούτων', it:'succo di frutta', ro:'suc de fructe', uk:'фруктовий сік'}, src: fruit_juice, group: 'fruit' },   
          { name: {en:'fruits', el:'φρούτα', it:'frutta', ro:'fructe', uk:'фрукти'}, src: fruits, group: 'fruit' },
          { name: {en:'pear', el:'αχλάδι', it:'pera', ro:'pară', uk:'груша'}, src: pear, group: 'fruit' },   
          { name: {en:'pineapple', el:'ανανάς', it:'ananas', ro:'ananas', uk:'ананас'}, src: pineapple, group: 'fruit' },
        ],
        cereals: [
          { name: {en:'chia seeds', el:'σπόροι τσία', it:'semi di chia', ro:'seminte de chia', uk:'насіння чіа'}, src: chia_seeds, group: 'cereals' },
          { name: {en:'muesli', el:'μούσλι', it:'muesli', ro:'musli', uk:'мюслі'}, src: muesli, group: 'cereals' },
          { name: {en:'nutritional yeast', el:'διατροφική μαγιά', it:'lievito nutrizionale', ro:'drojdie nutritivă', uk:'харчові дріжджі'}, src: nutritional_yeast, group: 'cereals' },
          { name: {en:'oats', el:'βρώμη', it:'avena', ro:'ovăz', uk:'овес'}, src: oats, group: 'cereals' },
          { name: {en: "whole grain cereal", el: "δημητριακά ολικής αλέσεως", it: "cereali integrali", ro: "cereale integrale", uk: "цільнозернові пластівці"}, src: cereals, group: 'cereals' },
        ],
        nuts: [
          { name: {en:'almonds', el:'αμύγδαλα', it:'mandorle', ro:'migdale', uk:'мигдаль'}, src: almonds, group: 'nuts' },
          { name: {en:'cashews', el:'κάσιους', it:'anacardi', ro:'caju', uk:'кешью'}, src: cashews, group: 'nuts' },
          { name: {en: "nut butter", el: "βούτυρο ξηρών καρπών", it: "burro di noci", ro: "unt de nuci", uk: "масло з горіхів"}, src: peanut_butter, group: 'nuts' },
          { name: {en:'nuts', el:'ξηροί καρποί', it:'noci', ro:'nuci', uk:'горіхи'}, src: nuts, group: 'nuts' },
          { name: {en:'peanut butter', el:'φυστικοβούτυρο', it:'burro di arachidi', ro:'unt de arahide', uk:'арахісове масло'}, src: peanut_butter, group: 'nuts' },
          { name: {en:'walnuts', el:'καρύδια', it:'noci', ro:'nuci', uk:'волоські горіхи'}, src: walnuts, group: 'nuts' },
        ],
        carbohydrates: [
          { name: {en:'barley', el:'κριθάρι', it:'orzo', ro:'orz', uk:'ячмінь'}, src: barley, group: 'carbohydrates' },
          { name: {en: "brown rice", el: "καστανό ρύζι", it: "riso integrale", ro: "orez brun", uk: "коричневий рис"}, src: rice, group: 'carbohydrates' },
          { name: {en:'buckwheat', el:'φαγόπυρο', it:'grano saraceno', ro:'hrişcă', uk:'гречана крупа'}, src: buckwheat, group: 'carbohydrates' },
          { name: {en:'bulgur', el:'πλιγούρι', it:'bulgur', ro:'bulgur', uk:'булгур'}, src: bulgur, group: 'carbohydrates' },
          { name: {en:'couscous', el:'κουσκούς', it:'couscous', ro:'cuscus', uk:'кус-кус'}, src: couscous, group: 'carbohydrates' },
          { name: {en:'farro', el:'δίκοκκο σιτάρι', it:'farro', ro:'farro', uk:'фарро'}, src: farro, group: 'carbohydrates' },
          { name: {en:'multi-grain bread', el:'πολύσπορο ψωμί', it:'pane multicereali', ro:'pâine cu mai multe cereale', uk:'багатозерновий хліб'}, src: whole_grain_bread, group: 'carbohydrates' },
          { name: {en:'quinoa', el:'κινόα', it:'quinoa', ro:'quinoa', uk:'кіноа'}, src: quinoa, group: 'carbohydrates' },
          { name: {en:'rye bread', el:'σικαλένιο ψωμί', it:'pane di segale', ro:'pâine de secară', uk:'житній хліб'}, src: rye_bread, group: 'carbohydrates' },
          { name: {en: "whole grain bread", el: "ψωμί ολικών σιτηρών", it: "pane integrale", ro: "pâine integrală", uk: "хліб з цільного зерна"}, src: whole_grain_bread, group: 'carbohydrates' },
          { name: {en: "whole wheat bread", el: "ψωμί ολικής άλεσης", it: "pane integrale di grano", ro: "pâine din grâu integral", uk: "хліб з цільної пшениці"}, src: whole_wheat_bread, group: 'carbohydrates' },
          { name: {en:'whole-wheat pasta', el:'ζυμαρικά ολικής αλέσεως', it:'pasta integrale', ro:'paste din grâu integral', uk:'цільнозернові макарони'}, src: pasta, group: 'carbohydrates' },
          { name: {en: "wild rice", el: "άγριο ρύζι", it: "riso selvatico", ro: "orez sălbatic", uk: "дикий рис"}, src: rice, group: 'carbohydrates' },
        ],
        lean_protein: [
          { name:{en:'shellfish', el:'οστρακοειδή', it:'crostacei', ro:'crustacee', uk:'молюски'}, src: shellfish, group: 'lean_protein' },
          { name: {en:'swordfish', el:'ξιφίας', it:'pesce spada', ro:'pește-spadă', uk:'риба-меч'}, src: swordfish, group: 'lean_protein' },
          { name: {en: "turkey/rabbit", el: "γαλοπούλα/κουνέλι", it: "tacchino/coniglio", ro: "curcan/iepure", uk: "індичка/кролик"}, src: turkey, group: 'lean_protein' },
          { name: {en:'white fish', el:'λευκό ψάρι', it:'pesce bianco', ro:'pește alb', uk:'біла риба'}, src: fish, group: 'lean_protein' },
        ],
        protein_1: [
          { name: {en:'beef', el:'βοδινό κρέας', it:'manzo', ro:'vită', uk:'яловичина'}, src: beef, group: 'protein_1' },
          { name: {en:'chicken', el:'κοτόπουλο', it:'pollo', ro:'pui', uk:'курка'}, src: chicken, group: 'protein_1' },
          { name: {en:'wild boar', el:'αγριόχοιρος', it:'cinghiale', ro:'mistret', uk:'дикий кабан'}, src: wild_boar, group: 'protein_1' },
        ],
        protein_2: [
          { name: {en:'salmon', el:'σολομός', it:'salmone', ro:'somon', uk:'лосось'}, src: salmon, group: 'protein_2' },
          { name: {en:'tuna', el:'τόνος', it:'tonno', ro:'ton', uk:'тунець'}, src: tuna, group: 'protein_2' },
        ],
        protein_3: [
          { name: {en:'mackerel', el:'σκουμπρί', it:'sgombro', ro:'macrou', uk:'скумбрія'}, src: mackerel, group: 'protein_3' },
          { name: {en:'trout', el:'πεστρόφα', it:'trota', ro:'păstrăv', uk:'форель'}, src: trout, group: 'protein_3' },
        ],
        plant_based_protein: [
          { name: {en:'beans', el:'φασόλια', it:'fagioli', ro:'fasole', uk:'квасоля'}, src: beans, group: 'plant_based_protein' },
          { name: {en:'chickpeas', el:'ρεβίθια', it:'ceci', ro:'naut', uk:'нут'}, src: chickpeas, group: 'plant_based_protein' },
          { name: {en:'lentils', el:'φακή', it:'lenticchie', ro:'linte', uk:'сочевиця'}, src: lentils, group: 'plant_based_protein' },
          { name: {en:'peas', el:'αρακάς', it:'piselli', ro:'mazăre', uk:'горох'}, src: peas, group: 'plant_based_protein' },
        ],
        veggetables: [
          { name: {en:'arugula', el:'ρόκα', it:'rucola', ro:'voinicică', uk:'рукола'}, src: arugula, group: 'veggetables' },
          { name: {en:'carrots', el:'καρότα', it:'carote', ro:'morcovi', uk:'морква'}, src: carrots, group: 'veggetables' },
          { name: {en:'cucumber', el:'αγγούρι', it:'cetriolo', ro:'castravete', uk:'огірок'}, src: cucumber, group: 'veggetables' },
          { name: {en:'veggetables', el:'λαχανικά', it:'verdure', ro:'legume', uk:'овочів'}, src: veggetables, group: 'veggetables' },
        ],
        morning_protein: [
          { name: {en:'bresaola', el:'μπρεζάολα', it:'bresaola', ro:'bresaola', uk:'брезаола'}, src: bresaola, group: 'morning_protein' },
          { name: {en:'eggs', el:'αυγά', it:'uova', ro:'ouă', uk:'яйця'}, src: eggs, group: 'morning_protein' },
        ],
      },
      // Your default meal plan (for 7 days) — here we include only two days for brevity.
      defaultMealPlan: [
        {
          // id: 1,
          name: {en:'Monday', el:'Δευτέρα', it:'Lunedì', ro:'Luni', uk:'Понеділок'},
          // meals: {
            breakfast: [
              { name: {en:'yogurt', el:'γιαούρτι', it:'yogurt', ro:'iaurt', uk:'йогурт'}, src: yogurt, group: 'yogurt' },
              { name: {en:'fruits', el:'φρούτα', it:'frutta', ro:'fructe', uk:'фрукти'}, src: fruits, group: 'fruit' },
              { name: {en:'oats', el:'βρώμη', it:'avena', ro:'ovăz', uk:'овес'}, src: oats, group: 'cereals' },
              { name: {en:'nuts', el:'ξηροί καρποί', it:'noci', ro:'nuci', uk:'горіхи'}, src: nuts, group: 'nuts' },
            ],
            morning_snack: [
              { name: {en:'nuts', el:'ξηροί καρποί', it:'noci', ro:'nuci', uk:'горіхи'}, src: nuts, group: 'nuts'},
            ],
            lunch: [
              { name: {en:'beef', el:'βοδινό κρέας', it:'manzo', ro:'vită', uk:'яловичина'}, src: beef, group: 'protein_1' },
              { name: {en: "whole wheat bread", el: "ψωμί ολικής άλεσης", it: "pane integrale di grano", ro: "pâine din grâu integral", uk: "хліб з цільної пшениці"}, src: whole_wheat_bread, group: 'carbohydrates' },
            ],
            afternoon_snack: [
              { name: {en:'milk', el:'γάλα', it:'latte', ro:'lapte', uk:'молоко'}, src: milk, group: 'yogurt' },
              { name: {en: "whole grain cereal", el: "δημητριακά ολικής αλέσεως", it: "cereali integrali", ro: "cereale integrale", uk: "цільнозернові пластівці"}, src: cereals, group: 'cereals'},
            ],
            dinner: [
              { name: {en:'lentils', el:'φακή', it:'lenticchie', ro:'linte', uk:'сочевиця'}, src: lentils, group: 'plant_based_protein'  },
              { name: {en: "brown rice", el: "καστανό ρύζι", it: "riso integrale", ro: "orez brun", uk: "коричневий рис"}, src: rice, group: 'carbohydrates' },
            ]
          // }
        },
        {
          // id: 2,
          name: {en:'Tuesday', el:'Τρίτη', it:'Martedì', ro:'Marți', uk:'Вівторок'},
          // meals: {
            breakfast: [
              { name: {en:'ricotta cheese', el:'τυρί ρικότα', it:'ricotta', ro:'brânză ricotta', uk:'сир Рікотта'}, src: ricotta, group: 'yogurt' },
              { name: {en: "whole grain toast", el: "τοστ με ψωμί ολικής", it: "toast integrale", ro: "toast din cereale integrale", uk: "тост із цільного зерна"}, src: toast },
              { name: {en:'fruits', el:'φρούτα', it:'frutta', ro:'fructe', uk:'фрукти'}, src: fruits, group: 'fruit' },
            ],
            morning_snack: [
              { name: {en:'cashews', el:'κάσιους', it:'anacardi', ro:'caju', uk:'кешью'}, src: cashews, group: 'nuts' },
              { name: {en:'pear', el:'αχλάδι', it:'pera', ro:'pară', uk:'груша'}, src: pear, group: 'fruit' },
            ],
            lunch: [
              { name: {en:'salmon', el:'σολομός', it:'salmone', ro:'somon', uk:'лосось'}, src: salmon, group: 'protein_2' },
              { name: {en:'quinoa', el:'κινόα', it:'quinoa', ro:'quinoa', uk:'кіноа'}, src: quinoa, group: 'carbohydrates'  },
            ],
            afternoon_snack: [
              { name: {en:'cashews', el:'κάσιους', it:'anacardi', ro:'caju', uk:'кешью'}, src: cashews, group: 'nuts' },
              { name: {en:'apple', el:'μήλο', it:'mela', ro:'măr', uk:'яблуко'}, src: apple, group: 'fruit' },
            ],
            dinner: [
              { name: {en:'white fish', el:'λευκό ψάρι', it:'pesce bianco', ro:'pește alb', uk:'біла риба'}, src: fish, group: 'lean_protein' },
              { name: {en:'whole-wheat pasta', el:'ζυμαρικά ολικής αλέσεως', it:'pasta integrale', ro:'paste din grâu integral', uk:'цільнозернові макарони'}, src: pasta, group: 'carbohydrates' },
            ],
          // }
        },
        {
          // id: 3,
          name: {en:'Wednesday', el:'Τετάρτη', it:'Mercoledì', ro:'Miercuri', uk:'Середа'},
          // meals: {
            breakfast: [
              { name: {en:'cookie', el:'κουλουράκι', it:'biscotto', ro:'prăjitură', uk:'печиво'}, src: cookie },
              { name: {en:'milk', el:'γάλα', it:'latte', ro:'lapte', uk:'молоко'}, src: milk, group: 'yogurt' },
              { name: {en:'fruits', el:'φρούτα', it:'frutta', ro:'fructe', uk:'фрукти'}, src: fruits, group: 'fruit' },
            ],
            morning_snack: [
              { name: {en: "edamer cheese", el: "τυρί ένταμερ", it: "formaggio edamer", ro: "brânză edamer", uk: "сир едамер" }, src: cheese, group: 'yogurt' },
              { name: {en:'pineapple', el:'ανανάς', it:'ananas', ro:'ananas', uk:'ананас'}, src: pineapple, group: 'fruit' },
            ],            
            lunch: [
              { name: {en:'chickpeas', el:'ρεβίθια', it:'ceci', ro:'naut', uk:'нут'}, src: chickpeas, group: 'plant_based_protein' },
              { name: {en:'bulgur', el:'πλιγούρι', it:'bulgur', ro:'bulgur', uk:'булгур'}, src: bulgur, group: 'carbohydrates' },
            ],
            afternoon_snack: [
              { name: {en:'hummus', el:'χούμους', it:'hummus', ro:'hummus', uk:'хумус'}, src: hummus },
              { name: {en: "whole grain toast", el: "τοστ με ψωμί ολικής", it: "toast integrale", ro: "toast din cereale integrale", uk: "тост із цільного зерна"}, src: toast },
              { name: {en:'veggetables', el:'λαχανικά', it:'verdure', ro:'legume', uk:'овочів'}, src: veggetables, group: 'veggetables' },
              // { name: 'olive oil', src: oil },
            ],
            dinner: [
              { name: {en:'lentils', el:'φακή', it:'lenticchie', ro:'linte', uk:'сочевиця'}, src: lentils, group: 'plant_based_protein' },
              { name: {en:'multi-grain bread', el:'πολύσπορο ψωμί', it:'pane multicereali', ro:'pâine cu mai multe cereale', uk:'багатозерновий хліб'}, src: whole_grain_bread, group: 'carbohydrates' },
            ],
          // }
        },
        {
          // id: 4,
          name: {en:'Thursday', el:'Πέμπτη', it:'Giovedì', ro:'Joi', uk:'Четвер'},
          // meals: {
            breakfast: [
              { name: {en:'yogurt', el:'γιαούρτι', it:'yogurt', ro:'iaurt', uk:'йогурт'}, src: yogurt, group: 'yogurt' },
              { name: {en:'fruits', el:'φρούτα', it:'frutta', ro:'fructe', uk:'фрукти'}, src: fruits, group: 'fruit' },
              { name: {en:'muesli', el:'μούσλι', it:'muesli', ro:'musli', uk:'мюслі'}, src: muesli, group: 'cereals' },
            ],
            morning_snack: [
              { name: {en:'bresaola', el:'μπρεζάολα', it:'bresaola', ro:'bresaola', uk:'брезаола'}, src: bresaola, group: 'morning_protein' },
              { name: {en: "fresh cheese", el: "φρέσκο τυρί", it: "formaggio fresco", ro: "brânză proaspătă", uk: "свіжий сир" }, src: fresh_cheese, group: 'yogurt' },
              { name: {en: "whole grain toast", el: "τοστ με ψωμί ολικής", it: "toast integrale", ro: "toast din cereale integrale", uk: "тост із цільного зерна"}, src: toast },
              { name: {en:'arugula', el:'ρόκα', it:'rucola', ro:'voinicică', uk:'рукола'}, src: arugula, group: 'veggetables' },
            ],
            lunch: [
              { name: {en: "fresh cheese", el: "φρέσκο τυρί", it: "formaggio fresco", ro: "brânză proaspătă", uk: "свіжий сир" }, src: fresh_cheese, group: 'yogurt' },
              { name: {en: "whole grain bread", el: "ψωμί ολικών σιτηρών", it: "pane integrale", ro: "pâine integrală", uk: "хліб з цільного зерна"}, src: whole_grain_bread, group: 'carbohydrates' },
            ],
            afternoon_snack: [
              { name: {en: "greek yogurt", el: "ελληνικό γιαούρτι", it: "yogurt greco", ro: "iaurt grecesc", uk: "грецький йогурт" }, src: yogurt, group: 'yogurt' },
              { name: {en:'fruit juice', el:'χυμός φρούτων', it:'frutta succo', ro:'suc de fructe', uk:'фруктовий сік'}, src: fruit_juice, group: 'fruit' },
            ],
            dinner: [
              { name: {en: "turkey/rabbit", el: "γαλοπούλα/κουνέλι", it: "tacchino/coniglio", ro: "curcan/iepure", uk: "індичка/кролик"}, src: turkey, group: 'lean_protein' },
              { name: {en:'quinoa', el:'κινόα', it:'quinoa', ro:'quinoa', uk:'кіноа'}, src: quinoa, group: 'carbohydrates' },
            ],
          // }
        },
        {
          // id: 5,
          name: {en:'Friday', el:'Παρασκευή', it:'Venerdì', ro:'Vineri', uk:'П’ятниця'},
          // meals: {
            breakfast: [
              { name: {en:'eggs', el:'αυγά', it:'uova', ro:'ouă', uk:'яйця'}, src: eggs, group: 'morning_protein' },
              { name: {en: "whole grain toast", el: "τοστ με ψωμί ολικής", it: "toast integrale", ro: "toast din cereale integrale", uk: "тост із цільного зерна"}, src: toast },
              { name: {en:'avocado', el:'αβοκάντο', it:'avocado', ro:'avocado', uk:'авокадо'}, src: avocado, group: 'fruit' },
            ],            
            morning_snack: [
              { name: {en:'nuts', el:'ξηροί καρποί', it:'noci', ro:'nuci', uk:'горіхи'}, src: nuts, group: 'nuts' },
              { name: {en:'dried fruits', el:'αποξηραμένα φρούτα', it:'frutta secca', ro:'fructe uscate', uk:'сухофрукти'}, src: dried_fruits, group: 'fruit' },
            ],            
            lunch: [
              { name: {en:'mackerel', el:'σκουμπρί', it:'sgombro', ro:'macrou', uk:'скумбрія'}, src: mackerel, group: 'protein_3' },
              { name: {en:'couscous', el:'κουσκούς', it:'couscous', ro:'cuscus', uk:'кус-кус'}, src: couscous, group: 'carbohydrates' },
            ], 
            afternoon_snack: [
              { name: {en:'yogurt', el:'γιαούρτι', it:'yogurt', ro:'iaurt', uk:'йогурт'}, src: yogurt, group: 'yogurt' },
              { name: {en:'berries', el:'μούρα', it:'bacche', ro:'fructe de padure', uk:'ягоди'}, src: berries, group: 'fruit' },
              { name: {en:'chia seeds', el:'σπόροι τσία', it:'semi di chia', ro:'seminte de chia', uk:'насіння чіа'}, src: chia_seeds, group: 'cereals' },
            ],      
            dinner: [
              { name: {en:'swordfish', el:'ξιφίας', it:'pesce spada', ro:'pește-spadă', uk:'риба-меч'}, src: swordfish, group: 'lean_protein' },
              { name: {en: "brown rice", el: "καστανό ρύζι", it: "riso integrale", ro: "orez brun", uk: "коричневий рис"}, src: rice, group: 'carbohydrates' },
            ],
          // }
        },
        {
          // id: 6,
          name: {en:'Saturday', el:'Σάββατο', it:'Sabato', ro:'Sâmbătă', uk:'Субота'},
          // meals: {
            breakfast: [
              { name: {en:'peanut butter', el:'φυστικοβούτυρο', it:'burro di arachidi', ro:'unt de arahide', uk:'арахісове масло'}, src: peanut_butter, group: 'nuts' },
              { name: {en: "whole grain bread", el: "ψωμί ολικών σιτηρών", it: "pane integrale", ro: "pâine integrală", uk: "хліб з цільного зерна"}, src: whole_grain_bread, group: 'carbohydrates' },
              { name: {en:'apple', el:'μήλο', it:'mela', ro:'măr', uk:'яблуко'}, src: apple, group: 'fruit' },
            ],
            morning_snack: [
              { name: {en:'popcorn', el:'ποπ κορν', it:'popcorn', ro:'Popcorn', uk:'попкорн'}, src: popcorn },
              { name: {en:'nutritional yeast', el:'διατροφική μαγιά', it:'lievito nutrizionale', ro:'drojdie nutritivă', uk:'харчові дріжджі'}, src: nutritional_yeast, group: 'cereals' },
            ],             
            lunch: [
              { name: {en:'pizza', el:'πίτσα', it:'pizza', ro:'pizza', uk:'піца'}, src: pizza },
          ],
            afternoon_snack: [
              { name: {en:'carrots', el:'καρότα', it:'carote', ro:'morcovi', uk:'морква'}, src: carrots, group: 'veggetables' },
              { name: {en:'hummus', el:'χούμους', it:'hummus', ro:'hummus', uk:'хумус'}, src: hummus },
            ],             
            dinner: [
              { name: {en:'pizza', el:'πίτσα', it:'pizza', ro:'pizza', uk:'піца'}, src: pizza },
            ],
          // }
        },
        {
          // id: 7,
          name: {en:'Sunday', el:'Κυριακή', it:'Domenica', ro:'Duminică', uk:'Неділя'},
          // meals: {
            breakfast: [
              { name: {en:'milk', el:'γάλα', it:'latte', ro:'lapte', uk:'молоко'}, src: milk, group: 'yogurt' },
              { name: {en:'oats', el:'βρώμη', it:'avena', ro:'ovăz', uk:'овес'}, src: oats, group: 'cereals' },
              { name: {en:'banana', el:'μπανάνα', it:'banana', ro:'banană', uk:'банан'}, src: banana, group: 'fruit' },
            ],
            morning_snack: [
              { name: {en:'oats', el:'βρώμη', it:'avena', ro:'ovăz', uk:'овес'}, src: oats, group: 'cereals' },
              { name: {en: "nut butter", el: "βούτυρο ξηρών καρπών", it: "burro di noci", ro: "unt de nuci", uk: "масло з горіхів"}, src: nut_butter, group: 'nuts'},
              { name: {en:'dried fruits', el:'αποξηραμένα φρούτα', it:'frutta secca', ro:'fructe uscate', uk:'сухофрукти'}, src: dried_fruits, group: 'fruit'},
            ],              
            lunch: [
              { name: {en:'beans', el:'φασόλια', it:'fagioli', ro:'fasole', uk:'квасоля'}, src: beans, group: 'plant_based_protein' },
              { name: {en: "whole grain bread", el: "ψωμί ολικών σιτηρών", it: "pane integrale", ro: "pâine integrală", uk: "хліб з цільного зерна"}, src: whole_grain_bread, group: 'carbohydrates'},
            ],  
            afternoon_snack: [
              { name: {en: "greek yogurt", el: "ελληνικό γιαούρτι", it: "yogurt greco", ro: "iaurt grecesc", uk: "грецький йогурт" }, src: yogurt, group: 'yogurt' },
              { name: {en:'cucumber', el:'αγγούρι', it:'cetriolo', ro:'castravete', uk:'огірок'}, src: cucumber, group: 'veggetables' },
            ],     
            dinner: [
              { name: {en:'lentils', el:'φακή', it:'lenticchie', ro:'linte', uk:'сочевиця'}, src: lentils, group: 'plant_based_protein' },
              { name: {en:'multi-grain bread', el:'πολύσπορο ψωμί', it:'pane multicereali', ro:'pâine cu mai multe cereale', uk:'багатозерновий хліб'}, src: whole_grain_bread, group: 'carbohydrates' },
            ],
          }
        // }
      ],

      // The working meal plan (deep clone of defaultMealPlan)
      mealPlan: []
    };
  },
  computed: {
    // Find the selected day object based on selectedDay
    selectedDayData() {
      return this.mealPlan.find(day => day.name === this.selectedDay) || { name: '', breakfast: {}, morning_snack: {}, lunch: {}, afternoon_snack: {}, dinner: {} };
    },
    // Compute the index of the selected day within mealPlan
    selectedDayIndex() {
      return this.mealPlan.findIndex(day => day.name === this.selectedDay);
    }
  },
  created() {
    this.language = localStorage.getItem("language") || "en"; // Default to English
    console.log("LANGUAGE "+this.language);
    this.loadWeeklyPlan();
  },
  methods: {
    async storeInIndexedDB(gameState) {
      return new Promise((resolve, reject) => {
        const request = indexedDB.open("GameDB", 1);
        request.onupgradeneeded = function (event) {
          const db = event.target.result;
          if (!db.objectStoreNames.contains("gameStates")) {
            db.createObjectStore("gameStates", { keyPath: "id", autoIncrement: true });
          }
        };

        request.onsuccess = function (event) {
          const db = event.target.result;
          const transaction = db.transaction("gameStates", "readwrite");
          const store = transaction.objectStore("gameStates");

          // Check for existing game state before saving
          const getAllRequest = store.getAll();
          getAllRequest.onsuccess = function () {
            const existingRecords = getAllRequest.result;
            const duplicate = existingRecords.find(
              (record) => record.gameName === gameState.gameName && record.datePlayed === gameState.datePlayed
            );

            if (!duplicate) {
              store.add(gameState);
            } else {
              console.warn("Duplicate game state detected. Skipping save.");
            }

            resolve();
          };

          getAllRequest.onerror = function (event) {
            reject("Error checking existing records:", event.target.error);
          };
        };

        request.onerror = function (event) {
          reject("Error opening IndexedDB:", event.target.error);
        };
      });
    },

    async getUnsyncedGameStates() {
      return new Promise((resolve, reject) => {
        const request = indexedDB.open("GameDB", 1);
        request.onsuccess = function (event) {
          const db = event.target.result;
          const transaction = db.transaction("gameStates", "readonly");
          const store = transaction.objectStore("gameStates");
          const getAllRequest = store.getAll();
          getAllRequest.onsuccess = function () {
            resolve(getAllRequest.result);
          };
          getAllRequest.onerror = function (event) {
            reject("Error retrieving game states:", event.target.error);
          };
        };
      });
    },

    async deleteSyncedGameStates(syncedGames) {
      return new Promise((resolve, reject) => {
        const request = indexedDB.open("GameDB", 1);
        request.onsuccess = function (event) {
          const db = event.target.result;
          const transaction = db.transaction("gameStates", "readwrite");
          const store = transaction.objectStore("gameStates");
          syncedGames.forEach((game) => {
            store.delete(game.id); // Delete only specific records
          });
          resolve();
        };
        request.onerror = function (event) {
          reject("Error clearing IndexedDB:", event.target.error);
        };
      });
    },

    async syncWithMongo() {
      if (this.isSyncing) return; // Prevent duplicate sync
      this.isSyncing = true;
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("User not authenticated. Cannot sync.");
        this.isSyncing = false;
        return;
      }
      try {
        const unsyncedGames = await this.getUnsyncedGameStates();
        if (unsyncedGames.length === 0) {
          console.log("No game states to sync.");
          this.isSyncing = false;
          return;
        }
        const response = await fetch("https://erebus2.athenarc.gr/duse/save-game-state", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ gameStates: unsyncedGames }),
        });
        if (response.ok) {
          console.log("Game states synced successfully.");
          await this.deleteSyncedGameStates(unsyncedGames);
        } else {
          console.error("Failed to sync game states.");
        }
      } catch (error) {
        console.error("Error syncing with MongoDB:", error);
      } finally {
        this.isSyncing = false; // Ensure flag is reset
      }
    },

    async saveGameState() {
      const token = localStorage.getItem("token");
      const username = localStorage.getItem("username");
      if (!username) {
        console.error("User not logged in. Cannot save game state.");
        return;
      }
      const gameState = {
        username,
        gameName: this.$route.name,
        score: this.score,
        datePlayed: new Date().toISOString(),
      };
      try {
        // Store in IndexedDB regardless of network status
        await this.storeInIndexedDB(gameState);

        if (navigator.onLine && token) {
          await this.syncWithMongo();
        } else {
          console.warn("No internet connection. Game state saved locally.");
        }
      } catch (error) {
        console.error("Error saving game state:", error);
      }
    },
    mounted() {
      console.log("Current route path:", this.$route.path);

      const daypart = this.$route.path.split("/")[2] || "daypart";
      this.daypart = daypart;
      this.startGame();

      // Check for internet connectivity
      window.addEventListener("online", async () => {
        console.log("Back online! Syncing game states...");
        await this.syncWithMongo();
      });
    },

    beforeUnmount() {
    if (sounds.ambient3) {
      sounds.ambient3.stop();
    }
      this.saveGameState();
    },


    beforeRouteLeave(to, from, next) {
      // Stop background music when leaving the route
      if (this.audio) {
        this.audio.pause();
        this.audio = null;
      }
      // Save game state when the user navigates away
      this.saveGameState();
      next();
    },

    async loadWeeklyPlan() {
      const token = localStorage.getItem("token");
      if (!token) return;
      try {
        const response = await fetch("https://erebus2.athenarc.gr/duse/get-weekly-plan", {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        });

    
        if (response.ok) {
          const data = await response.json();
          console.log("--->",data)

          //  Ensure it is initialized properly
          if (data.plan && Object.keys(data.plan).length > 0) {
            this.mealPlan = data.plan;
            this.mealPlan.forEach((day, index) => {
              day.name = this.dayNames[index] || day.name;
            });
            if (this.mealPlan.length > 0) {
              this.selectedDay = this.mealPlan[0].name;
            }
        
            }  
         else {
            
            this.mealPlan = JSON.parse(JSON.stringify(this.defaultMealPlan));
            this.mealPlan.forEach((day, index) => {
              day.name = this.dayNames[index] || day.name;
            });
            if (this.mealPlan.length > 0) {
              this.selectedDay = this.mealPlan[0].name;
            }
          }
        }
      } catch (error) {
        console.error("Error loading weekly plan:", error);
      }
    },

    async saveWeeklyPlan() {
      const token = localStorage.getItem("token");
      if (!token) return;
      console.log("XXX>",this.mealPlan);
      try {
        await fetch("https://erebus2.athenarc.gr/duse/save-weekly-plan", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },

          body: JSON.stringify({ plan: this.mealPlan }),
        });
      } catch (error) {
        console.error("Error saving weekly plan:", error);
      }
    },

        async goBack() {
        sounds.whoosh.play();
        if (sounds.ambient3) {
          sounds.ambient3.stop();
        }
      this.saveWeeklyPlan();
      this.$router.push({ name: 'MainScene' });
    },

    startGame() {
      this.overlayMessage = {     en: "Build your week plan!",     el: "Οργάνωσε το εβδομαδιαίο σου πρόγραμμα διατροφής!",     it: "Costruisci il piano della tua settimana!",     ro: "Construiește planul tău săptămânal!",     uk: "Створи свій план на тиждень!" }; 
      this.isOverlayVisible = true;
    },

    onStartGame() {
      this.isOverlayVisible = false;

      Howler.ctx.resume();
      sounds.start_sound.play();
      sounds.ambient3.play();
    },

    openEdit(dayIndex, mealKey, foodIndex) {
      this.currentDayIndex = dayIndex;
      this.currentMealKey = mealKey;
      this.currentFoodIndex = foodIndex;
      let mealValue = this.mealPlan[dayIndex][mealKey];
      if (Array.isArray(mealValue)) {
        this.currentMeal = mealValue[foodIndex];
      } else {
        this.currentMeal = mealValue;
      }
      // Set current alternatives based on the current meal item's group.
      this.currentAlternatives = this.alternativeGroups[this.currentMeal.group] || [];
      // Default selected alternative is the current one.
      this.selectedAlternative = this.currentMeal;
      this.showEditModal = true;
    },

    closeEdit() {
      this.showEditModal = false;
    },

    saveAlternativeMeal() {
      if (this.currentDayIndex !== null && this.currentMealKey !== '') {
        let mealValue = this.mealPlan[this.currentDayIndex][this.currentMealKey];
        if (Array.isArray(mealValue)) {
          this.mealPlan[this.currentDayIndex][this.currentMealKey][this.currentFoodIndex] = this.selectedAlternative;
        } else {
          this.mealPlan[this.currentDayIndex][this.currentMealKey] = this.selectedAlternative;
        }
      }
      this.closeEdit();
    },

    swapSnacks(dayIndex) {
      const day = this.mealPlan[dayIndex];
      const temp = day.morning_snack;
      day.morning_snack = day.afternoon_snack;
      day.afternoon_snack = temp;
    },

    swapLunchDinner(dayIndex) {
      const day = this.mealPlan[dayIndex];
      const temp = day.lunch;
      day.lunch = day.dinner;
      day.dinner = temp;
    },

    openSwapModal() {
      this.swapDay = this.selectedDay;
      this.swapWithDay = null;
      this.showSwapModal = true;
    },

    confirmSwap() {
      if (!this.swapWithDay || this.swapDay === this.swapWithDay) {
        alert("Please select a different day to swap with.");
        return;
      }
      const day1 = this.mealPlan.find(day => day.name === this.swapDay);
      const day2 = this.mealPlan.find(day => day.name === this.swapWithDay);
      if (day1 && day2) {
        [day1.breakfast, day2.breakfast] = [day2.breakfast, day1.breakfast];
        [day1.morning_snack, day2.morning_snack] = [day2.morning_snack, day1.morning_snack];
        [day1.lunch, day2.lunch] = [day2.lunch, day1.lunch];
        [day1.afternoon_snack, day2.afternoon_snack] = [day2.afternoon_snack, day1.afternoon_snack];
        [day1.dinner, day2.dinner] = [day2.dinner, day1.dinner];
        console.log(`Swapped meals between ${this.swapDay} and ${this.swapWithDay}`);
      }
      this.showSwapModal = false;
    },

    downloadPDF() {
      this.saveWeeklyPlan();
      // Capture the title element and day plans
      const titleElement = document.querySelector('#title-plan');
      const dayPlans = document.querySelectorAll('.day-plan');

      const titlePromise = html2canvas(titleElement, { scale: 1 });
      const dayPromises = Array.from(dayPlans).map(day =>
        html2canvas(day, { scale: 2 })
      );

      // Wait for both title and day canvases to be ready
      Promise.all([titlePromise, ...dayPromises]).then(canvases => {
        // Separate the title canvas from the day canvases
        const titleCanvas = canvases[0];
        const dayCanvases = canvases.slice(1);

        // Initialize jsPDF and calculate dimensions
        const pdf = new jsPDF('p', 'pt', 'a4');
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const margin = 50;
        const effectiveWidth = pdfWidth - 2 * margin;

        // Add the title canvas image to the first page
        const titleImgData = titleCanvas.toDataURL('image/png');
        const titleScaleFactor = effectiveWidth / titleCanvas.width;
        const titleImgHeight = titleCanvas.height * titleScaleFactor;
        pdf.addImage(titleImgData, 'PNG', margin, margin, effectiveWidth, titleImgHeight);

        // Determine the starting Y position after the title (with extra spacing)
        let currentY = margin + titleImgHeight + margin;

        // Process day canvases in groups (4 per page as before)
        const canvasesPerPage = 4;
        for (let i = 0; i < dayCanvases.length; i += canvasesPerPage) {
          // For pages after the first, add a new page and reset the Y offset
          if (i > 0) {
            pdf.addPage();
            currentY = margin;
          }
          const availableHeight = (pdfHeight - currentY - margin) / canvasesPerPage;

          // Process up to 4 day canvases on this page
          for (let j = 0; j < canvasesPerPage; j++) {
            if (i + j >= dayCanvases.length) break;

            const canvas = dayCanvases[i + j];
            const imgData = canvas.toDataURL('image/png');
            const canvasWidth = canvas.width;
            const canvasHeight = canvas.height;

            // Calculate scale factor and adjust the image height to fit within the available height
            let scaleFactor = effectiveWidth / canvasWidth;
            let dayImgHeight = canvasHeight * scaleFactor;
            if (dayImgHeight > availableHeight) {
              scaleFactor = availableHeight / canvasHeight;
              dayImgHeight = availableHeight;
            }
            const imgWidth = canvasWidth * scaleFactor;
            const offsetX = margin + (effectiveWidth - imgWidth) / 2;
            const offsetY = currentY + (availableHeight * j);

            pdf.addImage(imgData, 'PNG', offsetX, offsetY, imgWidth, dayImgHeight);
          }
        }
        
        // Save the generated PDF
        pdf.save('Weekly_Meal_Plan.pdf');
        console.log("===================");
        console.log(this.mealPlan);
      });
    },

    resetMealPlan() {
      // Deep clone the default meal plan and reset day names.
      this.mealPlan = JSON.parse(JSON.stringify(this.defaultMealPlan));
      this.mealPlan.forEach((day, index) => {
        day.name = this.dayNames[index];
      });
    }
  }
};
</script>

<style scoped>
/* Enable scrolling for the app if content overflows the viewport */
#game-container {
  font-family: Arial, sans-serif;
  text-align: center;
  padding: 20px;
  max-height: 100vh;
  overflow-y: auto;
}

.actions {
  margin-bottom: 20px;
}

.actions button {
  margin: 0 10px;
  padding: 8px 16px;
  cursor: pointer;
}

.selectedDay {
  margin-bottom: 20px;
}

.meal-table {
  width: 80%;
  border-collapse: collapse;
  margin: auto;
  background-color: rgba(255, 255, 255, 0.6); 
}

.meal-table th,
.meal-table td {
  border: 2px solid rgba(0, 0, 0, 0.2);
  /* padding: 8px; */
  vertical-align: middle;
}

.meal-table th {
  background-color: #f4f4f4;
}

.meal-item {
  margin-bottom: 5px;
  cursor: pointer;
  display: inline-block;
  margin-right: 10px;
  /* background-color: rgba(255, 255, 255, 0.6); */
  padding: 4px 8px;
}

.meal-img {
  max-width: 20px;
  max-height: 20px;
  /* display: block; */
  margin: 0 auto;
}

/* Hide the all-meal-plan container off-screen so it doesn't show in the UI, but is still rendered for PDF export */
#all-meal-plan, #title-plan {
  position: absolute;
  left: -9999px;
  top: 0;
  width: 1000px; 
}


.day-plan {
  margin-bottom: 40px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  width: 300px;
  max-width: 90%;
  text-align: center;
}

.meal-img-large {
  width: 100px;
  height: auto;
  margin: 10px auto;
}

.modal-actions {
  margin-top: 20px;
}

.modal-actions button {
  margin: 0 10px;
  padding: 8px 16px;
  cursor: pointer;
}

.selectedDay {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

label {
  margin-bottom: 10px;
  font-size: 1.2rem;
}

select {
  padding: 8px;
  font-size: 1rem;
  border-radius: 5px;
  border: 1px solid #ccc;
  text-align: center; /* Centers text inside the dropdown */
  text-align-last: center; /* Ensures the selected option is centered */
  width: 200px; /* Adjust width as needed */
}

option {
  text-align: center; /* Ensures options inside the dropdown are centered */
}

.back-button {
  position: absolute;
  top: 20px;
  left: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
  z-index: 1001;
}


.screenshot-button
{
  position: fixed;
  margin-top: 10px;
  bottom: 5%;
  font-size: 1.2rem;
  padding: 10px 20px;
  padding: 15px 20px;
  /* Increased padding for better touch targets */
  /* background-color: #00aaff; */
  background-color: rgba(0, 0, 0, 0.5);
  transition: all 0.3s ease;
  display: block;
  color: #fff;
  border: none;
  cursor: pointer;
  border-radius: 10px;
  width: 100px;
  /* Limit the width if necessary */
  /* margin: 20px auto;  Center the button horizontally */
  text-align: center;
  /* Ensure text is centered */
  z-index: 1;
}

.screenshot-button {
  left: 1%;
}

.screenshot-button:hover {
  background-color: #0077cc;
  transform: scale(1.1);
}

.export-button,
.reset-button {
  position: fixed;
  font-size: 1.2rem;
  padding: 10px 20px;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 10px;
  z-index: 1001; /* Ensure it's above other elements */
}
.export-button {
  top: 10px;  /* Moves the button to the top */
  right: 10px;
  font-size: 1.2rem;
}
.reset-button {
  top: 60px;  /* Moves the button to the top */
  left: 20px;
  font-size: 14px;
}

.export-button:hover, .reset-button:hover {
  background-color: #0077cc;
  transform: scale(1.1);
}

.swap-buttons, .confirm-button, .cancel-button {
  margin-top: 15px;
}

.swap-buttons button, .confirm-button, .cancel-button {
  background-color: rgba(0, 0, 0, 0.5);
  font-size: 14px;
  margin: 10px 10px;
  padding: 8px 16px;
  cursor: pointer;
  padding: 10px 20px;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 10px;
}

.confirm-button, .cancel-button {
  background-color: #0077cc;
  color: white;
  border: none;
  padding: 10px;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
}

.game-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow-y: manual;
}

.modal select {
  margin-bottom: 15px; /* adds space below each dropdown */
}

</style>
